import { useContext, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { EnvContext } from '../Context/EnvironmentProvider';
import { apiClient } from '../services/ApiClient';

export function useApiClient() {
  const { authState } = useOktaAuth();
  const { baseUrl, env } = useContext(EnvContext);
  const token = authState?.accessToken?.accessToken.toString();

  useEffect(() => {
    if (token && token !== 'NO TOKEN') {
      apiClient.setToken(token);
    }
  }, [token]);

  useEffect(() => {
    apiClient.setBaseURL(baseUrl);
  }, [env]);

  return { token };
}
